import { Box, Theme, Typography } from '@mui/material';
import { Button } from '@components/button';
import { IconButton } from '@components/iconButton';
import { Badge } from '@components/badge/Badge';
import { Bell, Times } from '@assets/svgs';
import { Link as RouterLink } from 'react-router-dom';
import { useStore } from '@store/GlobalStore';
import { useGetScreenSize } from '@utils/useGetScreenSize';
import { useLocation } from 'react-router-dom';
import { shallow } from 'zustand/shallow';
import { adjustFontSize, adjustLineHeight } from '@theme/styleOverrides/typography';

const headerSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '52px',
  backgroundColor: 'primary.dark',
} as const;

type NotificationPanelHeaderProps = {
  onClosePopover: () => void;
  onDismissAll: () => void;
  isDisabled: boolean;
  badgeCount: number;
};

export const NotificationPanelHeader = (props: NotificationPanelHeaderProps) => {
  const { onClosePopover, onDismissAll, badgeCount, isDisabled } = props;
  const { pathname } = useLocation();
  const { isCustomerUser, hasPayerProfile } = useStore((state) => state.userAuth, shallow);
  const { isMobileScreen } = useGetScreenSize();
  let paddingHeader = '8px';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={[headerSx, { padding: paddingHeader }]}>
        {/* update typography to use palette color for dark/light */}
        <Typography
          variant='h5'
          sx={{
            padding: '6px',
          }}
        >
          Notifications {isMobileScreen && <Badge badgeContent={badgeCount}></Badge>}
        </Typography>
        <IconButton
          variant='circularDark'
          onClick={onClosePopover}
          sx={{
            color: 'text.main',
            mt: '-5px',
          }}
        >
          {isMobileScreen ? (
            <Times />
          ) : (
            <Badge badgeContent={badgeCount}>
              <Bell width='20px' height='20px' />
            </Badge>
          )}
        </IconButton>
      </Box>
      <Box
        sx={{
          height: '32px',
          display: 'flex',
          justifyContent: isCustomerUser && !hasPayerProfile ? 'flex-end' : 'space-between',
          backgroundColor: ({ palette }: any) => `${palette.panel.dark}`,
        }}
      >
        {isCustomerUser && !hasPayerProfile ? null : (
          <RouterLink to='/settings/notification-preferences' onClick={() => onClosePopover()}>
            <Button
              variant='text'
              disabled={pathname === '/settings/notifications'}
              sx={({ palette }: Theme) => ({
                fontSize: `${adjustFontSize(12, palette.fontSize)}px`,
                lineHeight: `${adjustLineHeight(16, palette.fontSize)}px`,
              })}
            >
              Manage Notification Preferences
            </Button>
          </RouterLink>
        )}
        <Button
          variant='text'
          onClick={onDismissAll}
          disabled={isDisabled}
          sx={({ palette }: Theme) => ({
            fontSize: `${adjustFontSize(12, palette.fontSize)}px`,
            lineHeight: `${adjustLineHeight(16, palette.fontSize)}px`,
          })}
        >
          Dismiss All
        </Button>
      </Box>
    </Box>
  );
};
